var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_3523)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9358 -0.0183105C17.633 -0.0183105 18.3303 -0.0183105 19.0275 -0.0183105C19.864 0.124476 20.7081 0.252785 21.5596 0.366618C23.3279 0.724782 25.0037 1.32967 26.5872 2.18128C26.5989 2.23804 26.6356 2.26248 26.6973 2.2546C26.77 2.29018 26.8434 2.32684 26.9174 2.36458C26.9292 2.42133 26.9659 2.44578 27.0275 2.4379C27.1743 2.52344 27.3211 2.60898 27.4679 2.69452C27.4797 2.75127 27.5164 2.77571 27.578 2.76784C28.8937 3.58043 30.0802 4.55802 31.1376 5.70063C31.1589 5.78308 31.2078 5.84415 31.2844 5.88393C31.37 5.94504 31.4434 6.01836 31.5046 6.10389C31.5019 6.15987 31.5264 6.19653 31.578 6.21387C31.6269 6.23832 31.6636 6.27498 31.6881 6.32385C31.6968 6.39365 31.7335 6.44255 31.7982 6.47049C31.8471 6.49494 31.8838 6.5316 31.9083 6.58047C31.9056 6.63645 31.9301 6.67311 31.9817 6.69045C32.0184 6.70265 32.0428 6.72711 32.0551 6.76377C32.0524 6.81975 32.0768 6.85641 32.1284 6.87375C32.1651 6.88595 32.1896 6.91041 32.2018 6.94707C32.1992 7.00305 32.2236 7.03971 32.2752 7.05705C32.284 7.12685 32.3207 7.17575 32.3853 7.20369C32.5725 7.40297 32.7315 7.62293 32.8624 7.86356C32.8597 7.91954 32.8842 7.9562 32.9358 7.97354C32.9331 8.02952 32.9576 8.06618 33.0092 8.08352C33.0065 8.1395 33.031 8.17616 33.0826 8.1935C33.0799 8.24948 33.1044 8.28614 33.156 8.30348C33.207 8.35477 33.2437 8.41588 33.2661 8.48678C33.2634 8.54276 33.2879 8.57942 33.3395 8.59676C33.3702 8.6093 33.3825 8.63371 33.3762 8.67008C33.3735 8.72606 33.398 8.76272 33.4495 8.78006C33.5262 8.84737 33.5751 8.9329 33.5963 9.03668C33.5937 9.09266 33.6181 9.12932 33.6697 9.14666C33.7251 9.20828 33.7618 9.2816 33.7798 9.36662C33.7771 9.4226 33.8016 9.45926 33.8532 9.4766C34.449 10.5573 34.9138 11.6938 35.2477 12.886C35.2444 12.9832 35.2688 13.0687 35.3211 13.1426C35.3178 13.2398 35.3422 13.3253 35.3945 13.3992C35.7013 14.5295 35.897 15.6782 35.9817 16.8452C35.9817 17.6151 35.9817 18.3849 35.9817 19.1548C35.6695 23.2599 34.1588 26.8525 31.4495 29.9328C28.9165 32.7844 25.7789 34.6358 22.0367 35.4868C21.0487 35.7001 20.0579 35.8651 19.0642 35.9817C18.367 35.9817 17.6697 35.9817 16.9725 35.9817C16.3807 35.8882 15.7813 35.8087 15.1743 35.7434C14.6548 35.6604 14.1411 35.5565 13.633 35.4318C13.5619 35.3708 13.4763 35.3464 13.3762 35.3585C13.3022 35.3063 13.2166 35.2819 13.1193 35.2852C12.7432 35.2047 12.3762 35.0947 12.0184 34.9552C11.9767 34.8924 11.9155 34.868 11.8349 34.8819C10.972 34.5914 10.1525 34.2126 9.37615 33.7454C9.3588 33.6939 9.3221 33.6694 9.26606 33.6721C9.03971 33.5775 8.83175 33.4553 8.64221 33.3055C8.62485 33.254 8.58815 33.2295 8.53212 33.2322C8.42162 33.1893 8.32375 33.1282 8.23854 33.0489C8.22118 32.9974 8.18448 32.9729 8.12845 32.9756C8.10048 32.911 8.05153 32.8743 7.98166 32.8656C7.89531 32.8348 7.82192 32.7859 7.76148 32.719C7.74412 32.6674 7.70742 32.643 7.65138 32.6456C7.39814 32.5026 7.16573 32.3315 6.95414 32.1324C6.93678 32.0809 6.90008 32.0564 6.84404 32.0591C6.80735 32.0469 6.78287 32.0224 6.77065 31.9858C6.75329 31.9342 6.71659 31.9098 6.66056 31.9124C6.62386 31.9002 6.59938 31.8758 6.58716 31.8391C6.56981 31.7876 6.53311 31.7631 6.47707 31.7658C6.42815 31.7414 6.39146 31.7047 6.36698 31.6558C6.34962 31.6043 6.31292 31.5798 6.25689 31.5825C6.19571 31.5458 6.1468 31.497 6.1101 31.4359C6.09274 31.3843 6.05604 31.3599 6.00001 31.3625C5.92661 31.3137 5.86544 31.2526 5.81652 31.1792C5.76474 31.0907 5.69135 31.0296 5.59634 30.9959C4.50324 29.9779 3.56135 28.8415 2.77065 27.5866C2.77853 27.525 2.75407 27.4884 2.69726 27.4766C2.61163 27.33 2.526 27.1833 2.44037 27.0367C2.44826 26.9751 2.42379 26.9385 2.36698 26.9267C2.31756 26.828 2.26864 26.7302 2.22019 26.6334C2.22807 26.5719 2.20361 26.5352 2.1468 26.5234C0.939707 24.1559 0.217996 21.6509 -0.0183411 19.0082C-0.0183411 18.3238 -0.0183411 17.6395 -0.0183411 16.9552C0.0882329 16.1409 0.204441 15.3222 0.330283 14.499C0.393652 14.1604 0.473164 13.8305 0.568815 13.5092C0.621064 13.4353 0.64553 13.3498 0.642209 13.2526C0.69338 12.9771 0.766774 12.7083 0.862393 12.446C0.925263 12.4044 0.949729 12.3433 0.935787 12.2627C1.34691 11.0627 1.88513 9.92623 2.55047 8.85338C2.60207 8.83604 2.62654 8.79938 2.62386 8.7434C2.61756 8.70703 2.6298 8.68262 2.66056 8.67008C2.71217 8.65274 2.73663 8.61608 2.73395 8.5601C2.72766 8.52373 2.73989 8.49932 2.77065 8.48678C2.82226 8.46944 2.84672 8.43278 2.84404 8.3768C2.89565 8.35946 2.92012 8.3228 2.91744 8.26682C2.96905 8.24948 2.99351 8.21282 2.99083 8.15684C3.01323 8.08594 3.04993 8.02483 3.10092 7.97354C3.15253 7.9562 3.177 7.91954 3.17432 7.86356C3.23899 7.83563 3.27569 7.78672 3.28441 7.71692C3.28173 7.66094 3.3062 7.62428 3.35781 7.60694C3.40941 7.5896 3.43388 7.55294 3.4312 7.49696C3.43992 7.42716 3.47662 7.37826 3.54129 7.35033C3.5929 7.33298 3.61737 7.29633 3.61469 7.24035C3.67935 7.21241 3.71604 7.16351 3.72478 7.09371C3.73351 7.02391 3.77021 6.975 3.83487 6.94707C3.88647 6.92973 3.91094 6.89307 3.90826 6.83709C4.01784 6.67883 4.14019 6.53219 4.27524 6.39717C4.3399 6.36923 4.37659 6.32033 4.38533 6.25053C4.39755 6.21387 4.42203 6.18942 4.45872 6.17721C4.51032 6.15987 4.5348 6.12321 4.53212 6.06723C4.58103 5.99391 4.64221 5.9328 4.7156 5.88393C4.78026 5.85599 4.81696 5.80709 4.8257 5.73729C4.94801 5.59065 5.08258 5.45622 5.22937 5.33403C5.33946 5.2485 5.43733 5.15073 5.52294 5.04075C5.59634 4.94298 5.68195 4.85745 5.77982 4.78413C5.92426 4.70106 6.04658 4.59108 6.1468 4.45419C6.1468 4.42974 6.15902 4.41753 6.18349 4.41753C6.2785 4.38384 6.3519 4.32273 6.40368 4.23424C6.40368 4.20978 6.4159 4.19758 6.44037 4.19758C6.52291 4.17631 6.58404 4.12744 6.62386 4.05094C6.88327 3.8041 7.16463 3.58416 7.4679 3.39106C7.52393 3.39373 7.56063 3.36929 7.57799 3.31774C7.87601 3.08144 8.19406 2.8737 8.53212 2.69452C8.58815 2.6972 8.62485 2.67276 8.64221 2.6212C8.65476 2.59047 8.6792 2.57825 8.7156 2.58454C8.77164 2.58722 8.80834 2.56278 8.8257 2.51122C9.01593 2.37337 9.22386 2.26339 9.44955 2.18128C9.50559 2.18396 9.54228 2.15952 9.55964 2.10796C10.1348 1.79023 10.7342 1.52139 11.3578 1.30145C11.4385 1.31537 11.4996 1.29093 11.5413 1.22813C11.827 1.10855 12.1206 1.01079 12.422 0.934846C12.5564 0.926656 12.6787 0.889997 12.789 0.824867C12.9234 0.816677 13.0457 0.780017 13.156 0.714887C13.2442 0.668395 13.3421 0.643954 13.4495 0.641567C13.5469 0.644885 13.6325 0.620444 13.7064 0.568247C14.7688 0.293609 15.8453 0.0980901 16.9358 -0.0183105ZM22.1835 2.8045C22.2574 2.8567 22.3431 2.88114 22.4404 2.87782C22.6914 2.96956 22.9483 3.0551 23.211 3.13444C23.2635 3.17247 23.3247 3.19691 23.3945 3.20776C24.1713 3.51024 24.9297 3.85239 25.6697 4.23424C25.6871 4.28578 25.7238 4.31023 25.7798 4.30756C25.8804 4.38307 25.9905 4.44415 26.1101 4.49085C26.1275 4.5424 26.1642 4.56685 26.2202 4.56417C26.2375 4.61572 26.2742 4.64017 26.3303 4.63749C26.3428 4.66822 26.3673 4.68046 26.4037 4.67415C26.421 4.7257 26.4577 4.75015 26.5138 4.74747C26.5311 4.79902 26.5678 4.82347 26.6239 4.82079C26.6412 4.87234 26.6779 4.89679 26.734 4.89411C26.7513 4.94566 26.788 4.97011 26.844 4.96743C26.8614 5.01898 26.8981 5.04343 26.9541 5.04075C27.0294 5.1158 27.115 5.17691 27.211 5.22405C27.239 5.28865 27.2879 5.32531 27.3578 5.33403C27.3858 5.39863 27.4347 5.43529 27.5046 5.44401C27.563 5.52221 27.6364 5.58328 27.7248 5.62731C27.7421 5.67885 27.7788 5.70331 27.8349 5.70063C27.8471 5.73729 27.8716 5.76174 27.9083 5.77395C27.9256 5.82549 27.9623 5.84995 28.0184 5.84727C28.0428 5.89614 28.0795 5.9328 28.1284 5.95725C28.1564 6.02184 28.2054 6.0585 28.2752 6.06723C28.3119 6.12834 28.3608 6.17721 28.422 6.21387C28.45 6.27846 28.4989 6.31512 28.5688 6.32385C29.0212 6.78188 29.4677 7.24625 29.9083 7.71692C30.3167 8.20384 30.702 8.70483 31.0642 9.21998C31.0801 9.26434 31.1046 9.301 31.1376 9.32996C31.2599 9.52547 31.3823 9.72101 31.5046 9.91652C31.5204 9.96087 31.5449 9.99753 31.578 10.0265C31.6421 10.1668 31.7155 10.3012 31.7982 10.4298C31.814 10.4741 31.8385 10.5108 31.8716 10.5397C33.7798 14.2302 34.2202 18.0917 33.1927 22.1243C33.1472 22.1871 33.1228 22.2604 33.1193 22.3442C33.1193 22.3564 33.1193 22.3687 33.1193 22.3809C33.067 22.4547 33.0426 22.5403 33.0459 22.6375C32.6727 23.7378 32.2078 24.801 31.6514 25.8269C31.5998 25.8442 31.5753 25.8809 31.578 25.9369C31.5472 25.9494 31.535 25.9738 31.5413 26.0102C31.4897 26.0275 31.4652 26.0642 31.4679 26.1202C31.4371 26.1327 31.4249 26.1571 31.4312 26.1935C31.3796 26.2108 31.3551 26.2475 31.3578 26.3035C31.3062 26.3208 31.2817 26.3575 31.2844 26.4135C31.205 26.4986 31.1438 26.5964 31.1009 26.7067C31.0363 26.7347 30.9996 26.7836 30.9908 26.8534C30.9392 26.8707 30.9148 26.9074 30.9174 26.9634C30.8658 26.9807 30.8414 27.0174 30.844 27.0733C30.7794 27.1013 30.7427 27.1502 30.734 27.22C30.6693 27.2479 30.6326 27.2968 30.6239 27.3666C30.5456 27.4249 30.4844 27.4983 30.4404 27.5866C30.3888 27.6039 30.3643 27.6406 30.367 27.6966C30.3303 27.7088 30.3058 27.7332 30.2936 27.7699C30.242 27.7872 30.2175 27.8239 30.2202 27.8799C30.1713 27.9043 30.1346 27.941 30.1101 27.9898C30.0454 28.0178 30.0087 28.0667 30 28.1365C29.9266 28.1853 29.8654 28.2465 29.8165 28.3198C29.7838 28.3421 29.7471 28.3543 29.7064 28.3564C28.9145 27.8387 28.0705 27.4171 27.1743 27.0917C25.6351 26.5974 24.0938 26.1147 22.5505 25.6436C22.5566 26.2547 22.5505 26.8657 22.5321 27.4766C22.5038 27.6729 22.4732 27.8684 22.4404 28.0632C22.4052 28.1292 22.3807 28.2025 22.367 28.2831C22.3425 28.3686 22.3181 28.4542 22.2936 28.5397C22.2555 28.5922 22.2311 28.6533 22.2202 28.723C21.9577 29.2964 21.6764 29.8585 21.3762 30.4094C21.3246 30.4267 21.3001 30.4634 21.3028 30.5194C21.2517 30.5707 21.2151 30.6318 21.1927 30.7027C21.1411 30.72 21.1166 30.7567 21.1193 30.8126C21.0677 30.83 21.0432 30.8666 21.0459 30.9226C20.9635 31.026 20.8901 31.136 20.8257 31.2526C20.7741 31.2699 20.7496 31.3066 20.7523 31.3625C20.6876 31.3905 20.6509 31.4394 20.6422 31.5092C20.5315 31.6199 20.4337 31.7421 20.3486 31.8758C20.297 31.8931 20.2726 31.9298 20.2752 31.9858C20.2385 31.998 20.2141 32.0224 20.2018 32.0591C20.1372 32.087 20.1005 32.1359 20.0917 32.2057C20.0184 32.2546 19.9572 32.3157 19.9083 32.389C19.8436 32.417 19.8069 32.4659 19.7982 32.5357C19.5902 32.719 19.3945 32.9145 19.211 33.1222C19.0912 33.1807 18.9934 33.2662 18.9174 33.3788C18.854 33.3981 18.805 33.4348 18.7706 33.4888C18.7146 33.4861 18.6779 33.5106 18.6606 33.5621C18.1661 33.7817 17.689 33.7512 17.2294 33.4705C17.0519 33.3237 16.8807 33.171 16.7156 33.0122C16.6911 32.9634 16.6544 32.9267 16.6055 32.9023C16.5443 32.8534 16.4832 32.8045 16.422 32.7556C16.3883 32.6607 16.3271 32.5874 16.2385 32.5357C16.1529 32.4257 16.0551 32.3279 15.945 32.2424C15.9362 32.1726 15.8995 32.1237 15.8349 32.0957C15.8226 32.0591 15.7982 32.0346 15.7615 32.0224C15.7642 31.9664 15.7397 31.9298 15.6881 31.9124C15.5497 31.721 15.4029 31.5377 15.2477 31.3625C15.2504 31.3066 15.2259 31.2699 15.1743 31.2526C15.177 31.1966 15.1525 31.1599 15.1009 31.1426C15.1036 31.0866 15.0791 31.0499 15.0275 31.0326C14.9917 30.9485 14.9428 30.8752 14.8807 30.8126C14.8834 30.7567 14.8589 30.72 14.8073 30.7027C14.3828 30.0011 14.0159 29.2679 13.7064 28.5031C13.6956 28.4333 13.6711 28.3722 13.633 28.3198C13.5617 28.0426 13.5066 27.7616 13.4679 27.4766C13.4437 26.8896 13.4499 26.3031 13.4862 25.7169C13.5331 25.6844 13.5331 25.6478 13.4862 25.6069C13.464 25.6115 13.4518 25.6237 13.4495 25.6436C13.1237 25.7398 12.8057 25.8498 12.4954 25.9735C12.361 25.9817 12.2387 26.0184 12.1284 26.0835C12.0446 26.087 11.9712 26.1115 11.9083 26.1568C11.8109 26.1535 11.7253 26.178 11.6514 26.2302C11.517 26.2383 11.3947 26.275 11.2844 26.3401C11.1871 26.3368 11.1015 26.3613 11.0275 26.4135C10.9802 26.4048 10.9435 26.417 10.9174 26.4501C10.8201 26.4468 10.7345 26.4712 10.6606 26.5234C10.6132 26.5148 10.5765 26.527 10.5505 26.5601C10.4531 26.5568 10.3675 26.5812 10.2936 26.6334C10.2462 26.6247 10.2095 26.6369 10.1835 26.6701C10.0491 26.6783 9.9268 26.7149 9.81652 26.7801C9.57905 26.8388 9.34665 26.9121 9.11927 27C9.01296 27.0231 8.91509 27.0597 8.8257 27.11C8.22658 27.3177 7.65164 27.5743 7.10092 27.8799C7.04489 27.8772 7.00819 27.9016 6.99083 27.9532C6.93017 27.959 6.88125 27.9835 6.84404 28.0265C6.78801 28.0238 6.75131 28.0483 6.73395 28.0998C6.66298 28.1222 6.60181 28.1588 6.55047 28.2098C6.49443 28.2071 6.45773 28.2316 6.44037 28.2831C6.38434 28.2804 6.34764 28.3049 6.33028 28.3564C6.27296 28.3479 6.22404 28.3234 6.18349 28.2831C6.1101 28.1853 6.02448 28.0998 5.92661 28.0265C5.91788 27.9567 5.88118 27.9078 5.81652 27.8799C5.79204 27.831 5.75535 27.7943 5.70643 27.7699C5.70911 27.7139 5.68463 27.6772 5.63303 27.6599C5.62081 27.6232 5.59634 27.5988 5.55964 27.5866C5.56232 27.5306 5.53784 27.4939 5.48625 27.4766C5.47403 27.4399 5.44955 27.4155 5.41285 27.4033C5.40412 27.3335 5.36742 27.2846 5.30276 27.2566C5.29403 27.1868 5.25733 27.1379 5.19267 27.11C5.18393 27.0402 5.14724 26.9913 5.08258 26.9634C5.08526 26.9074 5.06078 26.8707 5.00918 26.8534C5.01186 26.7974 4.98738 26.7607 4.93579 26.7434C4.93847 26.6874 4.91399 26.6508 4.86239 26.6334C4.84654 26.5891 4.82206 26.5524 4.789 26.5234C4.79168 26.4675 4.7672 26.4308 4.7156 26.4135C4.71828 26.3575 4.69381 26.3208 4.64221 26.3035C4.64489 26.2475 4.62041 26.2108 4.56881 26.1935C4.57513 26.1571 4.56287 26.1327 4.53212 26.1202C4.5348 26.0642 4.51032 26.0275 4.45872 26.0102C4.46503 25.9738 4.45278 25.9494 4.42203 25.9369C4.4247 25.8809 4.40023 25.8442 4.34863 25.8269C4.34276 25.7663 4.31832 25.7174 4.27524 25.6803C4.27792 25.6243 4.25344 25.5876 4.20184 25.5703C3.84342 24.8787 3.52539 24.17 3.24771 23.444C3.23686 23.3742 3.21239 23.3131 3.17432 23.2607C3.06356 22.9149 2.95347 22.5727 2.84404 22.2342C2.84737 22.137 2.8229 22.0515 2.77065 21.9776C1.54882 16.7571 2.60693 12.0646 5.94496 7.90022C9.46261 3.86833 13.9091 2.00478 19.2844 2.30959C20.2647 2.3967 21.231 2.56167 22.1835 2.8045ZM15.1009 10.1731C15.1183 10.2247 15.155 10.2491 15.211 10.2465C15.2232 10.2831 15.2477 10.3076 15.2844 10.3198C15.3124 10.3844 15.3613 10.421 15.4312 10.4298C15.5168 10.5397 15.6147 10.6375 15.7248 10.723C15.7421 10.7746 15.7788 10.799 15.8349 10.7964C15.8593 10.8452 15.896 10.8819 15.945 10.9063C15.9623 10.9579 15.999 10.9823 16.0551 10.9797C16.0673 11.0163 16.0917 11.0408 16.1284 11.053C16.1458 11.1045 16.1825 11.129 16.2385 11.1263C16.2665 11.1909 16.3155 11.2275 16.3853 11.2363C16.4027 11.2878 16.4394 11.3123 16.4954 11.3096C17.4108 11.9805 18.4261 12.4448 19.5413 12.7027C19.6152 12.7549 19.7009 12.7793 19.7982 12.776C20.2513 12.902 20.7162 12.9936 21.1927 13.0509C22.0839 13.162 22.9769 13.2536 23.8716 13.3259C23.9101 13.3524 23.9346 13.389 23.945 13.4359C23.7824 14.3617 23.6356 15.2905 23.5046 16.222C23.4637 16.275 23.4576 16.3361 23.4862 16.4053C23.5244 16.378 23.5427 16.3414 23.5413 16.2953C23.7107 15.939 23.9309 15.6152 24.2018 15.3238C24.4027 15.2271 24.5678 15.2699 24.6973 15.4522C24.8536 15.8025 24.9026 16.1691 24.844 16.552C24.7751 16.9113 24.6589 17.2535 24.4954 17.5784C24.4438 17.5958 24.4193 17.6324 24.422 17.6884C24.3375 17.7852 24.2518 17.883 24.1651 17.9817C24.0917 18.0306 24.0306 18.0917 23.9817 18.165C23.8468 18.3119 23.749 18.4829 23.6881 18.6782C23.6365 18.6956 23.612 18.7322 23.6147 18.7882C23.2112 19.5456 22.8075 20.3032 22.4037 21.0611C22.3521 21.0785 22.3276 21.1151 22.3303 21.1711C22.2995 21.1836 22.2873 21.2081 22.2936 21.2444C22.242 21.2618 22.2175 21.2984 22.2202 21.3544C22.1894 21.3669 22.1772 21.3914 22.1835 21.4277C22.1319 21.4451 22.1074 21.4817 22.1101 21.5377C22.0585 21.555 22.034 21.5917 22.0367 21.6477C21.9851 21.665 21.9606 21.7017 21.9633 21.7577C21.9117 21.775 21.8872 21.8117 21.8899 21.8676C21.8253 21.8956 21.7886 21.9445 21.7798 22.0143C21.7431 22.0265 21.7186 22.0509 21.7064 22.0876C21.6548 22.1049 21.6304 22.1416 21.633 22.1976C21.5596 22.2464 21.4985 22.3076 21.4495 22.3809C21.3395 22.4664 21.2416 22.5642 21.156 22.6742C21.1315 22.6742 21.1193 22.6864 21.1193 22.7108C21.0494 22.7195 21.0004 22.7562 20.9725 22.8208C20.948 22.8208 20.9358 22.833 20.9358 22.8575C20.8798 22.8548 20.8431 22.8792 20.8257 22.9308C20.4461 23.1876 20.0424 23.3953 19.6147 23.554C19.5174 23.5507 19.4318 23.5751 19.3578 23.6273C17.9974 23.9244 16.7007 23.7533 15.4679 23.1141C15.4389 23.081 15.4022 23.0566 15.3578 23.0408C14.9829 22.7886 14.6404 22.4954 14.3303 22.1609C14.333 22.1049 14.3085 22.0683 14.2569 22.0509C14.2447 22.0143 14.2202 21.9898 14.1835 21.9776C14.1862 21.9216 14.1617 21.885 14.1101 21.8676C14.1128 21.8117 14.0883 21.775 14.0367 21.7577C14.0394 21.7017 14.0149 21.665 13.9633 21.6477C13.966 21.5917 13.9415 21.555 13.8899 21.5377C13.8962 21.5013 13.884 21.4769 13.8532 21.4644C13.8559 21.4084 13.8314 21.3717 13.7798 21.3544C13.4372 20.7187 13.0947 20.0833 12.7523 19.4481C12.755 19.3921 12.7305 19.3554 12.6789 19.3381C12.5491 19.0261 12.3901 18.7328 12.2018 18.4583C12.2045 18.4023 12.18 18.3656 12.1284 18.3483C12.1197 18.2785 12.083 18.2296 12.0184 18.2016C12.0096 18.1318 11.9729 18.0829 11.9083 18.055C11.8838 18.0061 11.8471 17.9695 11.7982 17.945C11.8009 17.8891 11.7764 17.8524 11.7248 17.8351C11.7126 17.7984 11.6881 17.7739 11.6514 17.7617C11.6541 17.7058 11.6296 17.6691 11.578 17.6518C11.5807 17.5958 11.5562 17.5591 11.5046 17.5418C11.2737 17.1203 11.1514 16.6681 11.1376 16.1854C11.1214 15.7773 11.2926 15.484 11.6514 15.3055C11.846 15.384 12.005 15.5063 12.1284 15.6721C12.1443 15.7165 12.1688 15.7531 12.2018 15.7821C12.2543 15.8993 12.3154 16.0092 12.3853 16.112C12.4378 16.215 12.4622 16.325 12.4587 16.442C12.5018 16.45 12.5385 16.4378 12.5688 16.4053C12.4843 16.2274 12.4354 16.0441 12.422 15.8554C12.3242 14.8292 12.2263 13.8028 12.1284 12.776C12.2054 12.3289 12.3828 11.9257 12.6606 11.5662C13.1805 10.7903 13.8961 10.3015 14.8073 10.0998C14.9044 10.129 15.0022 10.1534 15.1009 10.1731Z",
    fill: "#E77D1E",
    fillOpacity: 0.86
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7064 0.568168C13.6325 0.620365 13.5469 0.644806 13.4496 0.641488C13.5235 0.589292 13.6091 0.564851 13.7064 0.568168Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.156 0.714844C13.0457 0.779974 12.9234 0.816634 12.789 0.824823C12.8993 0.759693 13.0216 0.723034 13.156 0.714844Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.789 0.824951C12.6787 0.890081 12.5564 0.926741 12.422 0.934931C12.5323 0.869801 12.6546 0.833141 12.789 0.824951Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5413 1.22803C11.4996 1.29083 11.4384 1.31527 11.3578 1.30135C11.4103 1.26331 11.4714 1.23888 11.5413 1.22803Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55965 2.10786C9.54229 2.15942 9.50559 2.18386 9.44955 2.18118C9.46691 2.12963 9.50361 2.10519 9.55965 2.10786Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5872 2.18115C26.6316 2.19699 26.6683 2.22143 26.6972 2.25447C26.6356 2.26235 26.5989 2.23791 26.5872 2.18115Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9174 2.3645C26.9618 2.38034 26.9985 2.40478 27.0275 2.43782C26.9659 2.4457 26.9292 2.42126 26.9174 2.3645Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8257 2.51118C8.80834 2.56274 8.77164 2.58718 8.71561 2.5845C8.73296 2.53295 8.76966 2.50851 8.8257 2.51118Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.6422 2.62129C8.62484 2.67285 8.58814 2.69729 8.5321 2.69461C8.54946 2.64306 8.58616 2.61862 8.6422 2.62129Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4679 2.69458C27.5123 2.71042 27.549 2.73486 27.578 2.7679C27.5164 2.77577 27.4797 2.75133 27.4679 2.69458Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1835 2.8045C22.2808 2.80118 22.3664 2.82562 22.4404 2.87782C22.343 2.88113 22.2574 2.85669 22.1835 2.8045Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.211 3.13441C23.2917 3.12048 23.3528 3.14492 23.3945 3.20773C23.3246 3.19688 23.2635 3.17244 23.211 3.13441Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57799 3.31783C7.56063 3.36938 7.52393 3.39382 7.4679 3.39114C7.48525 3.33959 7.52195 3.31515 7.57799 3.31783Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.62385 4.05103C6.58404 4.12753 6.5229 4.1764 6.44037 4.19766C6.48019 4.12116 6.54132 4.07229 6.62385 4.05103Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6697 4.23433C25.7258 4.23165 25.7625 4.2561 25.7798 4.30765C25.7238 4.31032 25.6871 4.28587 25.6697 4.23433Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.40366 4.23413C6.35188 4.32263 6.27848 4.38374 6.18347 4.41743C6.23525 4.32893 6.30865 4.26782 6.40366 4.23413Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1101 4.49092C26.1661 4.48824 26.2028 4.5127 26.2202 4.56424C26.1642 4.56692 26.1275 4.54246 26.1101 4.49092Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2202 4.56416C26.2762 4.56149 26.3129 4.58594 26.3303 4.63748C26.2742 4.64016 26.2375 4.61571 26.2202 4.56416Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14679 4.4541C6.04657 4.59099 5.92426 4.70097 5.77982 4.78404C5.88004 4.64715 6.00235 4.53717 6.14679 4.4541Z",
    fill: "#5F5F5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4037 4.67403C26.4597 4.67135 26.4964 4.6958 26.5137 4.74735C26.4577 4.75002 26.421 4.72557 26.4037 4.67403Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5138 4.74751C26.5698 4.74484 26.6065 4.76929 26.6239 4.82083C26.5678 4.82351 26.5311 4.79906 26.5138 4.74751Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6238 4.82075C26.6799 4.81808 26.7166 4.84253 26.7339 4.89407C26.6779 4.89675 26.6412 4.8723 26.6238 4.82075Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7339 4.894C26.79 4.89132 26.8267 4.91577 26.844 4.96732C26.788 4.96999 26.7513 4.94554 26.7339 4.894Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.844 4.96748C26.9001 4.96481 26.9368 4.98926 26.9541 5.0408C26.8981 5.04348 26.8614 5.01903 26.844 4.96748Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.52295 5.04077C5.43733 5.15075 5.33946 5.24852 5.22937 5.33405C5.29054 5.19962 5.38838 5.10188 5.52295 5.04077Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.211 5.22412C27.2809 5.23285 27.3298 5.26951 27.3578 5.3341C27.2879 5.32538 27.239 5.28872 27.211 5.22412Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3578 5.33398C27.4277 5.34271 27.4766 5.37937 27.5046 5.44396C27.4347 5.43524 27.3858 5.39858 27.3578 5.33398Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7248 5.6274C27.7808 5.62472 27.8175 5.64917 27.8349 5.70072C27.7788 5.70339 27.7421 5.67894 27.7248 5.6274Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1376 5.70068C31.2142 5.74046 31.2631 5.80153 31.2844 5.88398C31.2078 5.84421 31.1589 5.78313 31.1376 5.70068Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8257 5.7373C4.81696 5.80711 4.78027 5.85601 4.71561 5.88394C4.72434 5.81414 4.76104 5.76524 4.8257 5.7373Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9083 5.77388C27.9643 5.7712 28.001 5.79566 28.0184 5.8472C27.9623 5.84988 27.9256 5.82542 27.9083 5.77388Z",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1284 5.95728C28.1983 5.966 28.2473 6.00266 28.2752 6.06726C28.2054 6.05853 28.1564 6.02187 28.1284 5.95728Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.53212 6.06714C4.5348 6.12312 4.51032 6.15978 4.45872 6.17712C4.45605 6.12114 4.48052 6.08448 4.53212 6.06714Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5046 6.10376C31.5562 6.1211 31.5807 6.15776 31.578 6.21374C31.5264 6.1964 31.5019 6.15974 31.5046 6.10376Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.422 6.21387C28.4919 6.22259 28.5409 6.25925 28.5688 6.32385C28.4989 6.31512 28.45 6.27846 28.422 6.21387Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.38533 6.25049C4.3766 6.32029 4.3399 6.36919 4.27524 6.39713C4.28397 6.32733 4.32067 6.27842 4.38533 6.25049Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6881 6.32373C31.7527 6.35167 31.7894 6.40057 31.7982 6.47037C31.7335 6.44244 31.6968 6.39353 31.6881 6.32373Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0734 6.50703C14.0561 6.55858 14.0194 6.58303 13.9633 6.58035C13.9807 6.52881 14.0174 6.50436 14.0734 6.50703Z",
    fill: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9082 6.58057C31.9598 6.59791 31.9843 6.63457 31.9816 6.69055C31.93 6.67321 31.9056 6.63655 31.9082 6.58057Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.055 6.76367C32.1066 6.78101 32.1311 6.81767 32.1284 6.87365C32.0768 6.85631 32.0524 6.81965 32.055 6.76367Z",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.90825 6.83716C3.91093 6.89314 3.88645 6.9298 3.83485 6.94714C3.83218 6.89116 3.85665 6.8545 3.90825 6.83716Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2018 6.94702C32.2534 6.96436 32.2779 7.00102 32.2752 7.057C32.2236 7.03966 32.1991 7.003 32.2018 6.94702Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1927 7.05708C13.1753 7.10863 13.1386 7.13308 13.0826 7.1304C13.0999 7.07886 13.1366 7.05441 13.1927 7.05708Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2752 7.05713C32.3399 7.08506 32.3766 7.13397 32.3853 7.20377C32.3207 7.17583 32.284 7.12693 32.2752 7.05713Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.72478 7.09375C3.71604 7.16355 3.67935 7.21245 3.61469 7.24039C3.6234 7.17059 3.6601 7.12168 3.72478 7.09375Z",
    fill: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0459 7.16699C13.0061 7.2435 12.9449 7.29237 12.8624 7.31363C12.9022 7.23712 12.9634 7.18825 13.0459 7.16699Z",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.61467 7.24023C3.61735 7.29621 3.59288 7.33287 3.54127 7.35021C3.5386 7.29423 3.56306 7.25757 3.61467 7.24023Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8624 7.31372C12.8106 7.40222 12.7372 7.46333 12.6422 7.49702C12.694 7.40852 12.7674 7.34741 12.8624 7.31372Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4312 7.49683C3.43388 7.55281 3.40941 7.58947 3.3578 7.60681C3.35512 7.55083 3.37959 7.51417 3.4312 7.49683Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4954 7.64355C12.4587 7.70467 12.4098 7.75353 12.3486 7.79019C12.3609 7.70467 12.4098 7.65576 12.4954 7.64355Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.28441 7.7168C3.27569 7.7866 3.23899 7.8355 3.17432 7.86344C3.18304 7.79364 3.21973 7.74473 3.28441 7.7168Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7248 7.8269C23.7764 7.84424 23.8009 7.8809 23.7982 7.93688C23.7466 7.91954 23.7221 7.88288 23.7248 7.8269Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1743 7.86353C3.17698 7.91951 3.15251 7.95616 3.10091 7.97351C3.09823 7.91753 3.12269 7.88087 3.1743 7.86353Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8624 7.86353C32.914 7.88087 32.9385 7.91753 32.9358 7.97351C32.8842 7.95616 32.8597 7.91951 32.8624 7.86353Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1651 7.97363C12.1564 8.04343 12.1197 8.09234 12.0551 8.12027C12.0638 8.05047 12.1005 8.00157 12.1651 7.97363Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9358 7.97363C32.9874 7.99097 33.0118 8.02763 33.0092 8.08361C32.9576 8.06627 32.9331 8.02961 32.9358 7.97363Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9082 8.04688C23.9598 8.06422 23.9843 8.10087 23.9816 8.15685C23.93 8.13951 23.9056 8.10285 23.9082 8.04688Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0092 8.0835C33.0608 8.10084 33.0852 8.1375 33.0826 8.19348C33.031 8.17614 33.0065 8.13948 33.0092 8.0835Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.99083 8.15674C2.99351 8.21272 2.96904 8.24938 2.91743 8.26672C2.91476 8.21074 2.93922 8.17408 2.99083 8.15674Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0826 8.1936C33.1342 8.21094 33.1586 8.2476 33.156 8.30358C33.1044 8.28624 33.0799 8.24958 33.0826 8.1936Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.91743 8.26685C2.92011 8.32283 2.89565 8.35949 2.84404 8.37683C2.84136 8.32085 2.86583 8.28419 2.91743 8.26685Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.84404 8.37671C2.84672 8.43269 2.82225 8.46935 2.77065 8.48669C2.76797 8.43071 2.79243 8.39405 2.84404 8.37671Z",
    fill: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8349 8.41333C11.8375 8.46931 11.8131 8.50597 11.7615 8.52331C11.7588 8.46733 11.7833 8.43067 11.8349 8.41333Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2018 8.4502C24.2534 8.46754 24.2779 8.5042 24.2752 8.56017C24.2236 8.54283 24.1991 8.50617 24.2018 8.4502Z",
    fill: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2661 8.48682C33.3177 8.50416 33.3421 8.54082 33.3395 8.5968C33.2879 8.57946 33.2634 8.5428 33.2661 8.48682Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7615 8.52344C11.7641 8.57942 11.7397 8.61608 11.6881 8.63342C11.6854 8.57744 11.7099 8.54078 11.7615 8.52344Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.73393 8.56006C2.73661 8.61604 2.71214 8.6527 2.66054 8.67004C2.65786 8.61406 2.68232 8.5774 2.73393 8.56006Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2752 8.56006C24.3268 8.5774 24.3513 8.61406 24.3486 8.67004C24.297 8.6527 24.2725 8.61604 24.2752 8.56006Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3761 8.67017C33.4277 8.68751 33.4522 8.72417 33.4495 8.78015C33.3979 8.76281 33.3735 8.72615 33.3761 8.67017Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.62386 8.74341C2.62653 8.79939 2.60207 8.83605 2.55046 8.85339C2.54778 8.79741 2.57225 8.76075 2.62386 8.74341Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3853 8.74341C24.4369 8.76075 24.4614 8.79741 24.4587 8.85339C24.4071 8.83605 24.3827 8.79939 24.3853 8.74341Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5963 9.03662C33.6479 9.05396 33.6724 9.09062 33.6697 9.1466C33.6181 9.12926 33.5936 9.0926 33.5963 9.03662Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0642 9.21997C31.121 9.23174 31.1455 9.2684 31.1376 9.32995C31.1045 9.30099 31.0801 9.26433 31.0642 9.21997Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7798 9.3667C33.8314 9.38404 33.8559 9.4207 33.8532 9.47668C33.8016 9.45934 33.7772 9.42268 33.7798 9.3667Z",
    fill: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.211 9.69653C11.2143 9.79376 11.1899 9.87928 11.1376 9.95315C11.1343 9.85593 11.1588 9.7704 11.211 9.69653Z",
    fill: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8257 9.73315C24.8779 9.80702 24.9024 9.89255 24.8991 9.98977C24.8468 9.9159 24.8224 9.83038 24.8257 9.73315Z",
    fill: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5046 9.9165C31.5614 9.92827 31.5859 9.96493 31.578 10.0265C31.5449 9.99752 31.5204 9.96086 31.5046 9.9165Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1009 10.173C15.157 10.1704 15.1937 10.1948 15.211 10.2464C15.155 10.249 15.1183 10.2246 15.1009 10.173Z",
    fill: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2844 10.3198C15.3543 10.3285 15.4032 10.3652 15.4312 10.4298C15.3613 10.4211 15.3124 10.3844 15.2844 10.3198Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7982 10.4297C31.855 10.4415 31.8794 10.4781 31.8716 10.5397C31.8385 10.5107 31.814 10.474 31.7982 10.4297Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7248 10.7231C15.7808 10.7204 15.8175 10.7449 15.8349 10.7964C15.7788 10.7991 15.7421 10.7746 15.7248 10.7231Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9449 10.9062C16.001 10.9035 16.0377 10.928 16.055 10.9795C15.999 10.9822 15.9623 10.9577 15.9449 10.9062Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1284 11.0529C16.1845 11.0503 16.2212 11.0747 16.2385 11.1263C16.1825 11.1289 16.1458 11.1045 16.1284 11.0529Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2385 11.1262C16.3084 11.1349 16.3574 11.1716 16.3853 11.2362C16.3154 11.2275 16.2665 11.1908 16.2385 11.1262Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3853 11.2363C16.4414 11.2336 16.478 11.2581 16.4954 11.3096C16.4394 11.3123 16.4027 11.2878 16.3853 11.2363Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.935791 12.2627C0.949732 12.3433 0.925266 12.4044 0.862396 12.446C0.873255 12.3762 0.897717 12.3151 0.935791 12.2627Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5413 12.7027C19.6386 12.6994 19.7242 12.7238 19.7982 12.776C19.7008 12.7793 19.6152 12.7549 19.5413 12.7027Z",
    fill: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2477 12.886C35.3 12.9599 35.3244 13.0454 35.3211 13.1426C35.2688 13.0687 35.2444 12.9832 35.2477 12.886Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8716 13.3259C23.9082 13.3259 23.9449 13.3259 23.9816 13.3259C23.9903 13.3733 23.9781 13.4099 23.9449 13.4359C23.9346 13.3891 23.9101 13.3524 23.8716 13.3259Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3211 13.1426C35.3734 13.2164 35.3978 13.302 35.3945 13.3992C35.3422 13.3253 35.3178 13.2398 35.3211 13.1426Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.642204 13.2524C0.645525 13.3497 0.621059 13.4352 0.56881 13.5091C0.565489 13.4118 0.589955 13.3263 0.642204 13.2524Z",
    fill: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0092 14.3523C24.9908 14.5229 25.0153 14.6817 25.0826 14.8289C25.0459 14.8289 25.0092 14.8289 24.9725 14.8289C24.9608 14.6627 24.973 14.5038 25.0092 14.3523Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6239 14.9389C10.6065 14.9905 10.5698 15.0149 10.5138 15.0122C10.5311 14.9607 10.5678 14.9362 10.6239 14.9389Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1284 15.6721C12.1853 15.6839 12.2097 15.7205 12.2018 15.7821C12.1688 15.7531 12.1443 15.7165 12.1284 15.6721Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.422 15.8555C12.4354 16.0441 12.4843 16.2274 12.5688 16.4054C12.5385 16.4378 12.5018 16.4501 12.4587 16.442C12.4622 16.325 12.4378 16.215 12.3853 16.1121C12.4208 16.0348 12.4331 15.9493 12.422 15.8555Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5046 16.2219C23.4983 16.2583 23.5105 16.2827 23.5413 16.2952C23.5427 16.3413 23.5244 16.3779 23.4863 16.4052C23.4576 16.336 23.4638 16.2749 23.5046 16.2219Z",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5046 17.5417C11.5562 17.5591 11.5807 17.5957 11.578 17.6517C11.5264 17.6344 11.5019 17.5977 11.5046 17.5417Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4954 17.5784C24.4981 17.6343 24.4736 17.671 24.422 17.6883C24.4193 17.6324 24.4438 17.5957 24.4954 17.5784Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.578 17.6516C11.6296 17.669 11.6541 17.7056 11.6514 17.7616C11.5998 17.7443 11.5753 17.7076 11.578 17.6516Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7248 17.835C11.7764 17.8523 11.8009 17.889 11.7982 17.9449C11.7466 17.9276 11.7221 17.8909 11.7248 17.835Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5872 17.9084C10.644 17.9202 10.6684 17.9569 10.6606 18.0184C10.6275 17.9895 10.603 17.9528 10.5872 17.9084Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6972 18.0916C10.7686 18.1112 10.8053 18.16 10.8073 18.2382C10.7532 18.2039 10.7165 18.155 10.6972 18.0916Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9083 18.0549C11.9729 18.0829 12.0096 18.1318 12.0184 18.2016C11.9537 18.1736 11.917 18.1247 11.9083 18.0549Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1651 17.9817C24.1407 18.0795 24.0795 18.1405 23.9817 18.165C24.0306 18.0917 24.0918 18.0306 24.1651 17.9817Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0183 18.2017C12.083 18.2296 12.1197 18.2785 12.1284 18.3483C12.0638 18.3204 12.0271 18.2715 12.0183 18.2017Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1284 18.3484C12.18 18.3657 12.2045 18.4024 12.2018 18.4584C12.1502 18.441 12.1258 18.4044 12.1284 18.3484Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6881 18.6782C23.6907 18.7342 23.6663 18.7709 23.6147 18.7882C23.612 18.7322 23.6365 18.6956 23.6881 18.6782Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6789 19.3381C12.7305 19.3555 12.755 19.3921 12.7523 19.4481C12.7007 19.4308 12.6762 19.3941 12.6789 19.3381Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9817 20.1812C12.0385 20.1929 12.0629 20.2296 12.0551 20.2911C12.022 20.2622 11.9975 20.2255 11.9817 20.1812Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4954 21.061C12.5522 21.0728 12.5767 21.1095 12.5688 21.171C12.5358 21.1421 12.5113 21.1054 12.4954 21.061Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4037 21.061C22.4063 21.117 22.3819 21.1537 22.3303 21.171C22.3276 21.115 22.3521 21.0784 22.4037 21.061Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2936 21.2444C22.2962 21.3004 22.2718 21.337 22.2202 21.3544C22.2175 21.2984 22.242 21.2617 22.2936 21.2444Z",
    fill: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7798 21.3545C13.8314 21.3718 13.8559 21.4085 13.8532 21.4645C13.8016 21.4471 13.7772 21.4105 13.7798 21.3545Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1835 21.4277C22.1862 21.4837 22.1617 21.5204 22.1101 21.5377C22.1074 21.4817 22.1319 21.4451 22.1835 21.4277Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8899 21.5376C13.9415 21.5549 13.966 21.5916 13.9633 21.6476C13.9117 21.6302 13.8872 21.5936 13.8899 21.5376Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1101 21.5376C22.1128 21.5936 22.0883 21.6302 22.0367 21.6476C22.034 21.5916 22.0585 21.5549 22.1101 21.5376Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9633 21.6477C14.0149 21.665 14.0394 21.7017 14.0367 21.7577C13.9851 21.7403 13.9606 21.7037 13.9633 21.6477Z",
    fill: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0367 21.6477C22.0394 21.7037 22.0149 21.7403 21.9633 21.7577C21.9606 21.7017 21.9851 21.665 22.0367 21.6477Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0367 21.7576C14.0883 21.7749 14.1128 21.8116 14.1101 21.8675C14.0585 21.8502 14.034 21.8135 14.0367 21.7576Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9633 21.7576C21.966 21.8135 21.9415 21.8502 21.8899 21.8675C21.8872 21.8116 21.9117 21.7749 21.9633 21.7576Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8899 21.8677C21.8812 21.9375 21.8445 21.9864 21.7798 22.0143C21.7885 21.9445 21.8252 21.8956 21.8899 21.8677Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1101 21.8677C14.1617 21.885 14.1862 21.9217 14.1835 21.9777C14.1319 21.9603 14.1074 21.9237 14.1101 21.8677Z",
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2569 22.051C14.3085 22.0684 14.333 22.105 14.3303 22.161C14.2787 22.1437 14.2542 22.107 14.2569 22.051Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7064 22.0876C21.7091 22.1436 21.6846 22.1803 21.633 22.1976C21.6304 22.1416 21.6548 22.105 21.7064 22.0876Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.77065 21.9775C2.8229 22.0514 2.84737 22.1369 2.84405 22.2342C2.7918 22.1603 2.76733 22.0748 2.77065 21.9775Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1927 22.1243C33.2015 22.2122 33.177 22.2855 33.1193 22.3442C33.1227 22.2604 33.1472 22.1871 33.1927 22.1243Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1193 22.3809C33.1226 22.4781 33.0981 22.5636 33.0459 22.6375C33.0426 22.5403 33.067 22.4547 33.1193 22.3809Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4496 22.3809C21.3884 22.5153 21.2905 22.613 21.156 22.6741C21.2416 22.5642 21.3395 22.4664 21.4496 22.3809Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1193 22.7107C21.0913 22.7753 21.0423 22.8119 20.9725 22.8207C21.0004 22.7561 21.0494 22.7194 21.1193 22.7107Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9358 22.8574C20.9184 22.9089 20.8817 22.9334 20.8257 22.9307C20.843 22.8792 20.8797 22.8547 20.9358 22.8574Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3578 23.0408C15.4022 23.0566 15.4389 23.0811 15.4679 23.1141C15.4063 23.122 15.3696 23.0975 15.3578 23.0408Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2202 23.1873C14.2901 23.196 14.339 23.2326 14.367 23.2972C14.2971 23.2885 14.2481 23.2519 14.2202 23.1873Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1743 23.2607C3.21237 23.3132 3.23683 23.3743 3.24769 23.444C3.18482 23.4024 3.16036 23.3413 3.1743 23.2607Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4771 23.4074C14.5331 23.4047 14.5698 23.4292 14.5871 23.4807C14.5311 23.4834 14.4944 23.459 14.4771 23.4074Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6606 23.5539C14.7166 23.5512 14.7533 23.5757 14.7706 23.6272C14.7146 23.6299 14.6779 23.6055 14.6606 23.5539Z",
    fill: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6147 23.554C19.5407 23.6062 19.4551 23.6306 19.3578 23.6273C19.4317 23.5751 19.5173 23.5507 19.6147 23.554Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9174 23.7373C14.9735 23.7346 15.0102 23.759 15.0275 23.8106C14.9715 23.8133 14.9348 23.7888 14.9174 23.7373Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0275 23.8105C15.0836 23.8078 15.1203 23.8323 15.1376 23.8838C15.0816 23.8865 15.0449 23.862 15.0275 23.8105Z",
    fill: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.211 23.9206C15.267 23.9179 15.3037 23.9424 15.3211 23.9939C15.2651 23.9966 15.2284 23.9722 15.211 23.9206Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4496 25.6436C13.4518 25.6237 13.464 25.6115 13.4863 25.6069C13.5331 25.6478 13.5331 25.6844 13.4863 25.7169C13.4926 25.6805 13.4803 25.6561 13.4496 25.6436Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.20183 25.5703C4.25342 25.5877 4.2779 25.6243 4.27522 25.6803C4.22363 25.663 4.19915 25.6263 4.20183 25.5703Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1743 26.0101C19.1939 26.0814 19.2429 26.1181 19.3211 26.1201C19.494 26.25 19.6347 26.4089 19.7431 26.5966C19.7676 26.6578 19.7676 26.7188 19.7431 26.7799C19.4017 27.1577 19.047 27.5243 18.6789 27.8797C18.6728 27.9225 18.6667 27.9653 18.6606 28.008C19.0157 28.9072 19.3766 29.8054 19.7431 30.7025C19.7676 30.7881 19.7676 30.8736 19.7431 30.9592C19.2486 31.4654 18.741 31.9603 18.2202 32.4439C18.1027 32.4983 17.9803 32.5105 17.8532 32.4806C17.8209 32.4546 17.7964 32.424 17.7798 32.3889C17.7625 32.3374 17.7258 32.3129 17.6697 32.3156C17.5963 32.2667 17.5352 32.2056 17.4862 32.1323C17.4689 32.0807 17.4322 32.0563 17.3761 32.059C17.2905 31.9979 17.2171 31.9245 17.156 31.839C17.128 31.7744 17.079 31.7377 17.0092 31.729C16.8991 31.6435 16.8012 31.5457 16.7156 31.4357C16.6876 31.3712 16.6387 31.3345 16.5688 31.3258C16.2663 31.1066 16.1868 30.8255 16.3303 30.4826C16.6821 29.6758 17.0185 28.8632 17.3395 28.0447C17.3244 27.9596 17.2938 27.8802 17.2477 27.8064C16.9427 27.5445 16.6552 27.2634 16.3853 26.9632C16.3833 26.8851 16.3466 26.8362 16.2752 26.8166C16.2372 26.6737 16.2739 26.5515 16.3853 26.45C16.4369 26.4327 16.4614 26.396 16.4587 26.34C16.4709 26.3034 16.4954 26.2789 16.5321 26.2667C16.602 26.258 16.6509 26.2213 16.6789 26.1567C16.7069 26.0921 16.7558 26.0555 16.8257 26.0467C16.8817 26.0494 16.9184 26.025 16.9358 25.9734C17.0348 25.9121 17.1449 25.8693 17.2661 25.8451C17.659 25.8437 18.0504 25.8376 18.4404 25.8268C18.7078 25.8081 18.9525 25.8691 19.1743 26.0101Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34862 25.8269C4.40021 25.8442 4.42469 25.8809 4.42201 25.9369C4.37042 25.9195 4.34594 25.8829 4.34862 25.8269Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6514 25.8269C31.6541 25.8829 31.6296 25.9195 31.578 25.9369C31.5753 25.8809 31.5998 25.8442 31.6514 25.8269Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4954 25.9736C12.3851 26.0388 12.2628 26.0754 12.1284 26.0836C12.2387 26.0185 12.361 25.9818 12.4954 25.9736Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9358 25.9736C16.9184 26.0251 16.8817 26.0496 16.8257 26.0469C16.843 25.9954 16.8797 25.9709 16.9358 25.9736Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1743 26.0103C19.2378 26.0295 19.2868 26.0662 19.3211 26.1202C19.2429 26.1183 19.1939 26.0816 19.1743 26.0103Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.45872 26.0103C4.51032 26.0276 4.5348 26.0643 4.53212 26.1202C4.48052 26.1029 4.45605 26.0662 4.45872 26.0103Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5413 26.0103C31.544 26.0662 31.5195 26.1029 31.4679 26.1202C31.4652 26.0643 31.4897 26.0276 31.5413 26.0103Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9082 26.1568C11.8343 26.209 11.7487 26.2334 11.6514 26.2301C11.7253 26.1779 11.8109 26.1535 11.9082 26.1568Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6789 26.1567C16.6509 26.2213 16.602 26.258 16.5321 26.2667C16.5601 26.2021 16.609 26.1655 16.6789 26.1567Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5688 26.1936C4.6204 26.2109 4.64488 26.2476 4.6422 26.3036C4.5906 26.2862 4.56612 26.2496 4.5688 26.1936Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6514 26.2302C11.5411 26.2954 11.4188 26.332 11.2844 26.3402C11.3947 26.2751 11.517 26.2384 11.6514 26.2302Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4312 26.1936C31.4339 26.2496 31.4094 26.2862 31.3578 26.3036C31.3551 26.2476 31.3796 26.2109 31.4312 26.1936Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6422 26.3035C4.69379 26.3208 4.71827 26.3575 4.71559 26.4134C4.66399 26.3961 4.63952 26.3594 4.6422 26.3035Z",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2844 26.3401C11.2105 26.3923 11.1248 26.4168 11.0275 26.4135C11.1015 26.3613 11.1871 26.3368 11.2844 26.3401Z",
    fill: "#5F5F5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4587 26.3401C16.4614 26.3961 16.4369 26.4327 16.3853 26.4501C16.3827 26.3941 16.4071 26.3574 16.4587 26.3401Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3578 26.3035C31.3605 26.3594 31.336 26.3961 31.2844 26.4134C31.2817 26.3575 31.3062 26.3208 31.3578 26.3035Z",
    fill: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71559 26.4133C4.76719 26.4307 4.79166 26.4673 4.78899 26.5233C4.73739 26.506 4.71291 26.4693 4.71559 26.4133Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9174 26.45C10.8435 26.5022 10.7579 26.5266 10.6606 26.5233C10.7345 26.4711 10.8201 26.4467 10.9174 26.45Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.14679 26.5234C2.2036 26.5352 2.22807 26.5719 2.22018 26.6334C2.18711 26.6045 2.16265 26.5678 2.14679 26.5234Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5505 26.5601C10.4765 26.6123 10.3909 26.6367 10.2936 26.6334C10.3675 26.5812 10.4531 26.5568 10.5505 26.5601Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.86238 26.6333C4.91398 26.6506 4.93845 26.6873 4.93578 26.7433C4.88418 26.7259 4.8597 26.6893 4.86238 26.6333Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1835 26.6702C10.0732 26.7353 9.95091 26.772 9.81653 26.7801C9.9268 26.715 10.0491 26.6783 10.1835 26.6702Z",
    fill: "#5D5D5D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1009 26.7068C31.0922 26.7766 31.0555 26.8255 30.9908 26.8534C30.9995 26.7836 31.0362 26.7347 31.1009 26.7068Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.93578 26.7434C4.98737 26.7607 5.01185 26.7974 5.00917 26.8534C4.95757 26.836 4.9331 26.7994 4.93578 26.7434Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2752 26.8167C16.3467 26.8363 16.3833 26.8851 16.3853 26.9633C16.3312 26.929 16.2945 26.8801 16.2752 26.8167Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.36697 26.9268C2.42378 26.9385 2.44825 26.9752 2.44037 27.0367C2.40729 27.0078 2.38283 26.9711 2.36697 26.9268Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00917 26.8533C5.06077 26.8706 5.08524 26.9073 5.08256 26.9633C5.03097 26.9459 5.00649 26.9093 5.00917 26.8533Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9908 26.8533C30.9935 26.9093 30.969 26.9459 30.9174 26.9633C30.9148 26.9073 30.9392 26.8706 30.9908 26.8533Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9174 26.9634C30.9201 27.0194 30.8956 27.056 30.844 27.0734C30.8414 27.0174 30.8658 26.9807 30.9174 26.9634Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.11926 27C9.04157 27.079 8.9437 27.1157 8.82568 27.11C8.91508 27.0597 9.01295 27.0231 9.11926 27Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19266 27.1099C5.25732 27.1378 5.29402 27.1867 5.30275 27.2565C5.23809 27.2286 5.20139 27.1797 5.19266 27.1099Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7339 27.22C30.7252 27.2898 30.6885 27.3387 30.6238 27.3666C30.6326 27.2968 30.6693 27.2479 30.7339 27.22Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.30276 27.2566C5.36743 27.2845 5.40412 27.3334 5.41286 27.4032C5.3482 27.3753 5.3115 27.3264 5.30276 27.2566Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.69724 27.4766C2.75405 27.4883 2.77851 27.525 2.77063 27.5865C2.73755 27.5576 2.71309 27.5209 2.69724 27.4766Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48625 27.4766C5.53785 27.4939 5.56233 27.5306 5.55965 27.5865C5.50805 27.5692 5.48357 27.5325 5.48625 27.4766Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4404 27.5867C30.443 27.6426 30.4186 27.6793 30.367 27.6966C30.3643 27.6407 30.3888 27.604 30.4404 27.5867Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.63304 27.6599C5.68464 27.6773 5.70911 27.7139 5.70644 27.7699C5.65484 27.7526 5.63036 27.7159 5.63304 27.6599Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2936 27.7698C30.2962 27.8258 30.2718 27.8624 30.2202 27.8798C30.2175 27.8238 30.242 27.7871 30.2936 27.7698Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81653 27.8799C5.88119 27.9078 5.91789 27.9567 5.92662 28.0265C5.86196 27.9986 5.82526 27.9497 5.81653 27.8799Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10091 27.8798C7.08355 27.9314 7.04685 27.9558 6.99081 27.9532C7.00817 27.9016 7.04487 27.8772 7.10091 27.8798Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1101 27.9897C30.1014 28.0595 30.0647 28.1085 30 28.1364C30.0087 28.0666 30.0454 28.0177 30.1101 27.9897Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.84404 28.0266C6.82668 28.0781 6.78998 28.1026 6.73395 28.0999C6.75131 28.0483 6.788 28.0239 6.84404 28.0266Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4404 28.0632C22.4567 28.1552 22.4323 28.2286 22.367 28.2832C22.3807 28.2026 22.4052 28.1293 22.4404 28.0632Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55046 28.2097C6.5331 28.2612 6.49641 28.2857 6.44037 28.283C6.45773 28.2314 6.49442 28.207 6.55046 28.2097Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.18347 28.2832C6.22402 28.3235 6.27294 28.348 6.33026 28.3565C6.2492 28.4106 6.20028 28.3862 6.18347 28.2832Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.44035 28.2832C6.423 28.3347 6.3863 28.3592 6.33026 28.3565C6.34762 28.3049 6.38432 28.2805 6.44035 28.2832Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8165 28.3198C29.7962 28.3951 29.7595 28.4073 29.7064 28.3565C29.7471 28.3544 29.7838 28.3422 29.8165 28.3198Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.633 28.3198C13.6711 28.3722 13.6956 28.4334 13.7064 28.5031C13.6436 28.4615 13.6191 28.4004 13.633 28.3198Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2936 28.5398C22.3075 28.6204 22.283 28.6815 22.2202 28.7231C22.231 28.6533 22.2555 28.5922 22.2936 28.5398Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3761 30.4094C21.3788 30.4654 21.3543 30.5021 21.3027 30.5194C21.3001 30.4634 21.3245 30.4268 21.3761 30.4094Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8073 30.7026C14.8589 30.72 14.8834 30.7566 14.8807 30.8126C14.8291 30.7953 14.8046 30.7586 14.8073 30.7026Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1927 30.7026C21.1954 30.7586 21.1709 30.7953 21.1193 30.8126C21.1166 30.7566 21.1411 30.72 21.1927 30.7026Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1193 30.8127C21.122 30.8687 21.0975 30.9054 21.0459 30.9227C21.0432 30.8667 21.0677 30.8301 21.1193 30.8127Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.59634 30.9958C5.69135 31.0295 5.76475 31.0907 5.81653 31.1791C5.72152 31.1455 5.64812 31.0843 5.59634 30.9958Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0275 31.0325C15.0791 31.0498 15.1036 31.0865 15.1009 31.1425C15.0493 31.1251 15.0248 31.0885 15.0275 31.0325Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1009 31.1426C15.1525 31.1599 15.177 31.1966 15.1743 31.2526C15.1227 31.2352 15.0982 31.1986 15.1009 31.1426Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1743 31.2524C15.2259 31.2698 15.2504 31.3064 15.2477 31.3624C15.1961 31.3451 15.1716 31.3084 15.1743 31.2524Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5688 31.3259C16.6387 31.3347 16.6876 31.3713 16.7156 31.4359C16.6457 31.4272 16.5968 31.3905 16.5688 31.3259Z",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8257 31.2524C20.8284 31.3084 20.8039 31.3451 20.7523 31.3624C20.7496 31.3064 20.7741 31.2698 20.8257 31.2524Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 31.3625C6.05604 31.3598 6.09273 31.3843 6.11009 31.4358C6.05406 31.4385 6.01736 31.414 6 31.3625Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7523 31.3625C20.7436 31.4323 20.7069 31.4813 20.6422 31.5092C20.6509 31.4394 20.6876 31.3905 20.7523 31.3625Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25687 31.5825C6.3129 31.5798 6.3496 31.6042 6.36696 31.6558C6.31092 31.6585 6.27422 31.634 6.25687 31.5825Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0092 31.729C17.0791 31.7377 17.128 31.7744 17.156 31.839C17.0861 31.8303 17.0371 31.7936 17.0092 31.729Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.47705 31.7658C6.53309 31.7631 6.56978 31.7876 6.58714 31.8391C6.53111 31.8418 6.49441 31.8174 6.47705 31.7658Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3486 31.8757C20.3513 31.9317 20.3268 31.9684 20.2752 31.9857C20.2725 31.9297 20.297 31.8931 20.3486 31.8757Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66055 31.9123C6.71659 31.9096 6.75329 31.9341 6.77064 31.9856C6.71461 31.9883 6.67791 31.9639 6.66055 31.9123Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6881 31.9124C15.7397 31.9297 15.7641 31.9664 15.7615 32.0223C15.7099 32.005 15.6854 31.9683 15.6881 31.9124Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3762 32.059C17.4322 32.0564 17.4689 32.0808 17.4863 32.1324C17.4302 32.135 17.3935 32.1106 17.3762 32.059Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.84402 32.059C6.90006 32.0564 6.93676 32.0808 6.95412 32.1324C6.89808 32.135 6.86138 32.1106 6.84402 32.059Z",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2018 32.0591C20.1931 32.1289 20.1564 32.1778 20.0917 32.2057C20.1005 32.1359 20.1372 32.087 20.2018 32.0591Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8349 32.0957C15.8995 32.1236 15.9362 32.1725 15.945 32.2423C15.8803 32.2144 15.8436 32.1655 15.8349 32.0957Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6697 32.3156C17.7258 32.313 17.7625 32.3374 17.7798 32.3889C17.7238 32.3916 17.6871 32.3672 17.6697 32.3156Z",
    fill: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9082 32.3889C19.8995 32.4587 19.8628 32.5076 19.7982 32.5356C19.8069 32.4658 19.8436 32.4169 19.9082 32.3889Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2385 32.5356C16.3271 32.5874 16.3883 32.6607 16.422 32.7556C16.3334 32.7039 16.2723 32.6306 16.2385 32.5356Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.65137 32.6457C7.7074 32.643 7.7441 32.6675 7.76146 32.719C7.70542 32.7217 7.66872 32.6972 7.65137 32.6457Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98166 32.8655C8.05153 32.8742 8.10048 32.9109 8.12845 32.9755C8.05858 32.9667 8.00962 32.9301 7.98166 32.8655Z",
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6055 32.9023C16.6544 32.9268 16.6911 32.9635 16.7156 33.0123C16.6422 33.0123 16.6055 32.9757 16.6055 32.9023Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.12845 32.9755C8.18449 32.9729 8.22118 32.9973 8.23854 33.0489C8.1825 33.0515 8.14581 33.0271 8.12845 32.9755Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.211 33.1223C19.1351 33.235 19.0372 33.3205 18.9174 33.3789C18.9933 33.2663 19.0912 33.1808 19.211 33.1223Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5321 33.2321C8.58814 33.2295 8.62484 33.2539 8.6422 33.3055C8.58616 33.3081 8.54946 33.2837 8.5321 33.2321Z",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7706 33.4887C18.7533 33.5403 18.7166 33.5647 18.6606 33.562C18.6779 33.5105 18.7146 33.486 18.7706 33.4887Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26605 33.6721C9.32209 33.6694 9.35879 33.6938 9.37614 33.7454C9.32011 33.7481 9.28341 33.7236 9.26605 33.6721Z",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8349 34.882C11.9155 34.868 11.9767 34.8925 12.0184 34.9553C11.9485 34.9444 11.8873 34.92 11.8349 34.882Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1193 35.2852C13.2166 35.2819 13.3022 35.3063 13.3761 35.3585C13.2788 35.3618 13.1932 35.3374 13.1193 35.2852Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3762 35.3585C13.4763 35.3464 13.5619 35.3708 13.633 35.4318C13.5388 35.4237 13.4532 35.3992 13.3762 35.3585Z",
    fill: "#7D7D7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_3523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLogo);
export default __webpack_public_path__ + "static/media/profile-logo.53d5892444db96c3f9373e66c0ec5112.svg";
export { ForwardRef as ReactComponent };